import * as yup from 'yup';
import { InitialOperetorLicenses } from './HEOperatorCertificateType-utils';


export const InitialOperetorLicensesInitialValues: InitialOperetorLicenses = {
  id: '',
  name: '',
  operatorType: '',
  isActive: 'true',
};

export const OperetorLicensesSchema = yup.object({
    name: yup.string().trim().required('Name is required'),
    operatorType: yup.string().trim().required('Operator Type is required'),
    validity: yup
      .number()
      .typeError('Validity must be a number')
      .required('Validity is required')
      .test('is-integer', 'Validity must be an integer', value =>
        value === undefined ? true : Number.isInteger(value)
      )
      .min(1, 'Validity must be greater than 0'),
    isActive: yup.boolean().required('Status is required'),
  });